import { Component, inject, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { CARD_ADMIN, Group_CardAdmin } from 'src/app/Interfaces/Admin/Administrator_General.inferface';
import { UserDataCDMS } from 'src/app/Interfaces/GeneralCDMS/User/User.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { LibraryCDMS } from 'src/app/types/General/Library.type';
import { GeneralRoleCDMS, typeRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { firstValueFrom } from 'rxjs';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';

@Component({
    selector: 'app-all-recyclebin-cdms',
    templateUrl: './all-recyclebin-cdms.component.html',
    styleUrls: ['./all-recyclebin-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class AllRecyclebinCDMSComponent implements OnInit {

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR CARDS RECYCLE BIN ==================+\\

  public AllRecycleBin: Group_CardAdmin[] = []

  public AllRecycleBinCopy: Group_CardAdmin[] = [
    {
      Title: 'Administrative Processes',
      NotRelated: [],
      Roles: [
        this.RolesGeneral.SuperAdministrator,
        this.RolesGeneral.AdministratorFIN,
        this.RolesGeneral.AdministratorSEC,
        this.RolesGeneral.AdministratorIT,
        this.RolesGeneral.RecycleBinFIN,
        this.RolesGeneral.RecycleBinSEC,
        this.RolesGeneral.RecycleBinIT],
      Library: [
        {
          Title: 'Processes',
          Description: 'puede consultar la papelera de reciclaje de directorios, procesos y anexos de la librería Processes.',
          ButtonText: 'Ver papelera',
          RouteLink: '/Dashboard/FIN/MenuRecycleBinFIN',
          Icon: 'fa-recycle',
          IconButton: 'fa-trash-can',
          Roles: [this.RolesGeneral.SuperAdministrator, this.RolesGeneral.AdministratorFIN, this.RolesGeneral.RecycleBinFIN]
        },
        {
          Title: 'HOE',
          Description: 'puede consultar la papelera de reciclaje de la librería HOE.',
          ButtonText: 'Ver papelera',
          RouteLink: '/Dashboard/Lib/hoe/RecycleBin',
          Icon: 'fa-recycle',
          IconButton: 'fa-trash-can',
          Roles: [this.RolesGeneral.SuperAdministrator, this.RolesGeneral.AdministratorHOE, this.RolesGeneral.RecycleBinHOE]
        },
      ]
    }
  ]

  //-========================= SERVICES =========================-\\

  public UserService = inject(UserDataService);
  private MasterLibraryService = inject(LibraryMasterService);

  constructor() { }

  async ngOnInit(): Promise<void> {
    await this.LoadDynamicRecycleLibraries();
    await this.fillTemplateRecycle()
  }

  private async LoadDynamicRecycleLibraries(): Promise<void> {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      if (!res.success) {
        return;
      }

      const staticSlugs = ['processes', 'fin', 'ccp', 'hoe'];

      for (const lib of res.operation || []) {
        const slug = String(lib?.Slug || '').toLowerCase();
        const slugUpper = String(lib?.Slug || '').toUpperCase();
        const libName = String(lib?.Nombre || slugUpper);

        if (!slug || staticSlugs.includes(slug)) {
          continue;
        }

        const administratorRole = `Administrator${slugUpper}` as typeRoleCDMS;
        const recycleRole = `RecycleBin${slugUpper}` as typeRoleCDMS;

        // Verificar que no exista ya un grupo para esta librería
        const existsGroup = this.AllRecycleBinCopy.some(g =>
          g.Library.some((item: CARD_ADMIN) => item.RouteLink === `/Dashboard/Lib/${slug}/RecycleBin`)
        );

        if (!existsGroup) {
          // Cada librería dinámica tiene su propio grupo con su propio título
          this.AllRecycleBinCopy.push({
            Title: libName,
            NotRelated: [],
            Roles: [administratorRole, recycleRole],
            Library: [
              {
                Title: libName,
                Description: `puede consultar la papelera de reciclaje de la librería ${libName}.`,
                ButtonText: 'Ver papelera',
                RouteLink: `/Dashboard/Lib/${slug}/RecycleBin`,
                Icon: 'fa-recycle',
                IconButton: 'fa-trash-can',
                Roles: [this.RolesGeneral.SuperAdministrator, administratorRole, recycleRole]
              }
            ]
          });
        }
      }
    } catch (e) {
      console.error('Error loading dynamic recycle libraries', e);
    }
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async fillTemplateRecycle(): Promise<void> {
    const userData: UserDataCDMS = await firstValueFrom(this.UserService.GetDataUser.pipe(first(value => value.ID !== 0)));

    const userRoles: typeRoleCDMS[] = userData.Role;
    const userLibraries = new Set((userData.Library || []).map((lib: LibraryCDMS) => String(lib || '').trim().toUpperCase()));

    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_My_Active_Libraries());
      if (res.success && Array.isArray(res.operation)) {
        for (const library of res.operation) {
          const slug = String(library?.Slug || '').trim().toUpperCase();
          if (slug) {
            userLibraries.add(slug);
            if (slug === 'FIN' || slug === 'PROCESSES') {
              userLibraries.add('FIN');
              userLibraries.add('PROCESSES');
            }
          }
        }
      }
    } catch (error) {
      // Fallback silencioso al set local de librerías del token.
    }

    this.AllRecycleBin = [];

    for (const library of this.AllRecycleBinCopy) {
      const tempLibrary: Group_CardAdmin = {
        Title: library.Title,
        Roles: library.Roles,
        NotRelated: [],
        Library: []
      }

      for (const recycle of library.Library) {
        const roleBasedAccess = userRoles.some((item: typeRoleCDMS) => recycle.Roles.some((role: typeRoleCDMS) => item === role));
        const recycleSlug = this.ExtractLibrarySlugFromRecycleRoute(recycle.RouteLink);
        const libraryBasedAccess = recycleSlug !== '' && userLibraries.has(recycleSlug);

        // Permitir tarjeta si el usuario tiene acceso por rol o por librería.
        const hasAccess = roleBasedAccess || libraryBasedAccess;
        hasAccess ? tempLibrary.Library.push(recycle) : tempLibrary.NotRelated.push(0)
      }

      if (tempLibrary.Library.length > 0) {
        this.AllRecycleBin.push(tempLibrary)
      }
    }

  }

  private ExtractLibrarySlugFromRecycleRoute(routeLink: string): string {
    const route = String(routeLink || '').trim();
    if (route.includes('/Dashboard/FIN/')) {
      return 'FIN';
    }

    const dynamicMatch = route.match(/\/Dashboard\/Lib\/([^/]+)\/RecycleBin/i);
    if (dynamicMatch && dynamicMatch[1]) {
      return String(dynamicMatch[1]).trim().toUpperCase();
    }

    return '';
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

}
